import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSlide } from "../../tutorial.models";

export const NETWORK_SETTINGS_SLIDES: TutorialSlide[] = [
    {
        key: 'Welcome-Network',
        title: 'Network Settings! 👋',
        messages: [{ text: "We're almost done! The MedicAI Network lets you add the contact details of colleagues you frequently work with for patient referrals. By adding their information here, you can easily send communication with just a click." }],
        highlightTarget: 'NETWORK',
        forceOpenTarget: true,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideDoNotShowAgain: true,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.COLLEAGUE_ADDED, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Network-Finish',
        title: 'Completed Network Settings!',
        messages: [
            { text: "You are done!" },
        ],
        highlightTarget: 'CLEAR',
        hasBackdrop: true,
        //position: { vertical: 'center', horizontal: 'center' },
        dimensions: { width: '450px' },
        actions: [
            {
                text: 'Finish',
                color: 'primary',
                actionName: SlideAction.SHOW_CLOSING_SLIDE, //Need to clos
            },
        ],
        position: { x: 700, y: 350 },
        hideDoNotShowAgain: true,
        progressBar: 100,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.COLLEAGUE_ADDED, type: SlideHideConditionType.OR },
        ],
    },
];